import { useMutation, useQueryClient } from "@tanstack/react-query";
import { keys } from "./keys";
import { recordRecentClientRequest } from "./recent-clients.api";

export const useRecordRecentClient = () => {
    const qc = useQueryClient();

    return useMutation({
        mutationFn: recordRecentClientRequest,
        onSuccess: (data) => {
            if (!data?.recorded) {
                return;
            }

            qc.invalidateQueries({ queryKey: keys.home.dashboardRoot() });

            if (typeof window !== "undefined") {
                window.dispatchEvent(new CustomEvent("mfp-recent-clients-updated"));
            }
        }
    });
};
